export default __webpack_public_path__ + "static/media/ai-art-icon-active.011b8f23.svg";